import { createRouter, createMemoryHistory, Router } from 'vue-router'

import Login from './Login/Login.vue'
import Favorites from './Favorites/Favorites.vue'
import Feedbacks from './Feedbacks/Feedbacks.vue'
import Home from './Home/Home.vue'
import Knowledge from './Home/Knowledge.vue'
import Collection from './Home/Collection.vue'
import Content from './Home/Content.vue'
import Notifications from './Notifications/Notifications.vue'
import Settings from './Settings/Settings.vue'
import Error from './Error.vue'

import { applyMiddlewares } from './utils'

const routes = [
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'index',
    path: '/',
    component: Home,
    meta: { tabIndex: 0, authorize: ['LoggedIn'] },
    children: [
      {
        path: '/knowledges/:knowledgeId',
        name: 'knowledge-viewer',
        component: Knowledge,
        meta: { tabIndex: 0, authorize: ['LoggedIn'] }
      },
      {
        path: '/cases/:id',
        name: 'collection-viewer',
        component: Collection,
        meta: { tabIndex: 0, authorize: ['LoggedIn'] }
      }
    ]
  },
  {
    path: '/contents/:id',
    name: 'content-viewer',
    component: Content,
    meta: { tabIndex: 0, authorize: ['LoggedIn'] }
  },
  {
    name: 'favorites',
    path: '/favorites',
    component: Favorites,
    meta: { tabIndex: 1, authorize: ['LoggedIn'] }
  },
  {
    name: 'notifications',
    path: '/notifications',
    component: Notifications,
    meta: { tabIndex: 2, authorize: ['LoggedIn'] }
  },
  {
    name: 'feedbacks',
    path: '/feedbacks',
    component: Feedbacks,
    meta: { tabIndex: 3, authorize: ['LoggedIn'] }
  },
  {
    name: 'settings',
    path: '/settings',
    component: Settings,
    meta: { tabIndex: 4, authorize: ['LoggedIn'] }
  },
  {
    path: '/:catchAll(.*)',
    component: Error
  }
]

export default function (): Router {
  const router = createRouter({
    history: createMemoryHistory(), // To debug use createWebHashHistory(),
    routes
  })

  router.beforeEach(
    applyMiddlewares([
      pageTransition,
      isAuthenticated,
      homeTabRedirections,
      lastEntityRouteHandler,
      fetchKnowledgeData,
      fetchContentMainData,
      fetchContentModalData
    ])
  )

  return router
}
